/**
 * Created by gilk on 06/03/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var BrandAppActivationView = require("manager-views/data-sources/conversation-sources/brand-app/BrandAppActivationView");

    var BrandAppController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        BrandAppController = Marionette.Controller.extend({
            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function() {
                return this._getMainView();
            },
            showActivationView: function() {
                this._showActivationView();
            },

            _initialize:function () {
                LEManager.logger.debug("BrandAppController:initialize");
                this.channel = LEManager.media.channel("conversationSources");

                this._bindEvents();
            },

            _bindEvents: function(){
                LEManager.logger.debug("call of _bindEvents","BrandAppController:_bindEvents");

                this.listenTo(this.channel, "brandApp:close", this._onCloseClick);
            },

            _getMainView: function() {
                LEManager.logger.debug("BrandAppController:getMainView - started");

                this._initPageComponent();
                return this.pageView;
            },

            _initPageComponent: function(){
                LEManager.logger.debug ("BrandAppController:_initPageComponent");

                this.pageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    header: {
                        title: LE.translator.translate("LEManager.dataSources.conversationSources.brandApp.title")
                    },
                    hasActionStrip: false
                });

                /* fired when the inside page view is being closed.
                 * do not move this to _bindEvents as this should be called everytime _initPageComponent is called (when pageView is closed) */
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _onPageClose: function(closedPageView) {
                LEManager.logger.debug("Page component in brand app is closed.", "BrandAppController:_onPageClose");
                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.pageView && closedPageView && closedPageView.cid === this.pageView.cid) {
                    this.pageView = null;
                    this.insideView = null;
                }
            },

            _showActivationView: function() {
                LEManager.logger.debug("call of show Activation","BrandAppController:_showActivationView");

                this.insideView = new BrandAppActivationView();
                this.pageView.setInsideView(this.insideView);
            },

            _onCloseClick: function(){
                LEManager.logger.debug("call of _onCloseClick","BrandAppController:_onCloseClick");
                LEManager.router.navigateBack();
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    return BrandAppController;
});
